/** @jsx jsx */
import { jsx, css } from "@emotion/core"
import { lazy, Suspense } from "react"
import { Switch, Route, useRouteMatch, Redirect } from "react-router-dom"
import OrganizationNavBar from "../components/Organization/NavBar"
import Cart from "./Cart"
import AdminRoute from "../components/UI/AdminRoute"
import OrganizationMobileNavBar from "../components/Organization/MobileNavBar"
import { LinearProgress } from "@material-ui/core"
import { isDeviceMobile } from "../components/utils/utils"

const Users = lazy(() => import("./Users"))
const Products = lazy(() => import("./Products"))
const Discounts = lazy(() => import("./Discounts"))
const Orders = lazy(() => import("./Orders"))

function Organization() {
    const { path } = useRouteMatch()

    const isMobile = isDeviceMobile()

    return (
        <div css={isMobile ? styles.root : null}>
            {isMobile ? <OrganizationMobileNavBar /> : <OrganizationNavBar />}

            <Suspense fallback={<LinearProgress />}>
                <Switch>
                    <Route
                        exact
                        path={path}
                        component={() => (
                            <Redirect to={{ pathname: `${path}/products` }} />
                        )}
                    />
                    <AdminRoute path={`${path}/users`}>
                        <Users />
                    </AdminRoute>
                    <AdminRoute path={`${path}/discounts`}>
                        <Discounts />
                    </AdminRoute>
                    <Route path={`${path}/products`} component={Products} />
                    <Route path={`${path}/cart`} component={Cart} />
                    <Route path={`${path}/orders`}>
                        <Orders />
                    </Route>
                </Switch>
            </Suspense>
        </div>
    )
}

export default Organization

const styles = {
    root: css`
        margin-bottom: 7vh;
    `,
}
